import { serviceTemplateModel } from '~/models';
import { getPMDetails } from '../pm.utils';
export var MappedStatus = /*#__PURE__*/ function(MappedStatus) {
    MappedStatus["Mapped"] = "mapped";
    MappedStatus["Unmapped"] = "unmapped";
    return MappedStatus;
}({});
export const serviceColumns = (param)=>{
    let { pmName, items, emptySearchText } = param;
    return [
        {
            type: 'text',
            name: 'service',
            header: 'Anchor service',
            width: {
                initial: 400,
                min: 200
            }
        },
        {
            type: 'multiSelect',
            name: 'mapping',
            header: "".concat(getPMDetails(pmName).name, " ").concat(getPMDetails(pmName).template),
            width: {
                initial: 400,
                min: 300
            },
            emptySearchText,
            selectBi: {
                name: 'pm_service_mapping'
            },
            options: ()=>items.map((item)=>({
                        value: item.id,
                        label: item.name
                    }))
        }
    ];
};
export const toServiceRows = (templates, getIntegratedIds)=>templates.map((template)=>({
            id: template.id,
            service: "".concat(template.name).concat(serviceTemplateModel.isDeleted(template) ? ' (Archived)' : ''),
            mapping: getIntegratedIds(template)
        }));
export function filterTemplates(templates, search, mappedStatusFilter, getServiceTemplateIntegratedIds) {
    const trimmedLowercaseSearch = search.trim().toLowerCase();
    return templates.filter((template)=>{
        const includedBySearch = !trimmedLowercaseSearch || template.name.toLowerCase().includes(trimmedLowercaseSearch);
        const isMapped = getServiceTemplateIntegratedIds(template).length > 0;
        const includedByMappedStatus = mappedStatusFilter.length === 0 || mappedStatusFilter.includes("mapped") && isMapped || mappedStatusFilter.includes("unmapped") && !isMapped;
        return includedBySearch && includedByMappedStatus;
    });
}
